// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.exam_test,
.error_exam_block {
  position: relative;
}
.exam_test .question_block .question_Name,
.error_exam_block .question_block .question_Name {
  position: relative;
  padding-left: 30px;
  font: 400 15px/25px "Ubuntu", sans-serif;
}
.exam_test .question_block .question_Name .question_No,
.error_exam_block .question_block .question_Name .question_No {
  font: 600 16px/25px "Ubuntu", sans-serif;
  position: absolute;
  left: 0;
  color: #00c596;
}
.exam_test .question_options,
.error_exam_block .question_options {
  position: relative;
}
.exam_test .question_options .single_card,
.error_exam_block .question_options .single_card {
  position: relative;
}
.exam_test .question_options .single_card:hover, .exam_test .question_options .single_card:focus, .exam_test .question_options .single_card:active, .exam_test .question_options .single_card.active,
.error_exam_block .question_options .single_card:hover,
.error_exam_block .question_options .single_card:focus,
.error_exam_block .question_options .single_card:active,
.error_exam_block .question_options .single_card.active {
  box-shadow: 0px 3px 20px hsla(0, 0%, 0%, 0.051);
  border: 1px solid rgba(0, 197, 150, 0.2392156863);
}
.exam_test .question_options .single_card:hover .option_name .option_No, .exam_test .question_options .single_card:focus .option_name .option_No, .exam_test .question_options .single_card:active .option_name .option_No, .exam_test .question_options .single_card.active .option_name .option_No,
.error_exam_block .question_options .single_card:hover .option_name .option_No,
.error_exam_block .question_options .single_card:focus .option_name .option_No,
.error_exam_block .question_options .single_card:active .option_name .option_No,
.error_exam_block .question_options .single_card.active .option_name .option_No {
  background: #c2f1e6;
}
.exam_test .question_options .single_card.incorrect,
.error_exam_block .question_options .single_card.incorrect {
  box-shadow: 0px 3px 20px hsla(0, 0%, 0%, 0.051);
  border: 1px solid hsla(14, 100%, 50%, 0.239);
}
.exam_test .question_options .single_card.incorrect .option_name .option_No,
.error_exam_block .question_options .single_card.incorrect .option_name .option_No {
  background: #f1c2c2;
}
.exam_test .question_options .single_card .option_name,
.error_exam_block .question_options .single_card .option_name {
  position: relative;
  padding-left: 30px;
}
.exam_test .question_options .single_card .option_name .option_No,
.error_exam_block .question_options .single_card .option_name .option_No {
  position: absolute;
  left: 0;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-radius: 4px;
  color: #707070;
  background: #eeeeee;
}
.exam_test .question_options .single_card .custom-radio .custom-control-input:checked ~ .custom-control-label::after,
.error_exam_block .question_options .single_card .custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  color: #fff;
  content: "\\f00c";
  font-family: "Font Awesome 5 Pro";
  font-weight: 900;
  background-image: none;
  border-radius: 0.46rem;
  text-align: center;
  line-height: 16px;
  font-size: 8px;
}
.exam_test .question_options .single_card .custom-control-input:checked ~ .custom-control-label,
.error_exam_block .question_options .single_card .custom-control-input:checked ~ .custom-control-label {
  color: #00c596;
}
.exam_test .question_options .single_card .custom-checkbox .custom-control-label::before,
.error_exam_block .question_options .single_card .custom-checkbox .custom-control-label::before {
  border-radius: 0.45rem;
}
.exam_test .question_options .single_card .custom-control-input:checked ~ .custom-control-label::before,
.error_exam_block .question_options .single_card .custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  background: #00c596;
  border: 1px solid #00a881;
}
.exam_test .question_options .single_card .custom-control-input:focus ~ .custom-control-label::before,
.error_exam_block .question_options .single_card .custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(0, 168, 129, 0.25);
}
.exam_test .question_options .single_card .correct,
.error_exam_block .question_options .single_card .correct {
  color: #00c596;
}
.exam_test .question_options .single_card .incorrect,
.error_exam_block .question_options .single_card .incorrect {
  color: #ff0000;
}
.exam_test .question_options .incorrect .custom-checkbox .custom-control-input:checked ~ .custom-control-label::after,
.error_exam_block .question_options .incorrect .custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  color: #fff;
  background: #ff0000;
  border: 1px solid #f00101;
  content: "\\f00d";
  font-weight: 900;
  font-family: "Font Awesome 5 Pro";
  background-image: none;
  border-radius: 0.46rem;
  text-align: center;
  line-height: 15px;
  font-size: 10px;
}
.exam_test .instruction button,
.error_exam_block .instruction button {
  font-size: 13px;
  border-radius: 25px;
}
.exam_test .instruction .helpTags li i,
.error_exam_block .instruction .helpTags li i {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/student_module/components/exams/_preexam.scss"],"names":[],"mappings":"AAAA;;EAEE,kBAAA;AACF;AACE;;EACE,kBAAA;EACA,kBAAA;EACA,wCAAA;AAEJ;AAAI;;EACE,wCAAA;EACA,kBAAA;EACA,OAAA;EACA,cAAA;AAGN;AACE;;EACE,kBAAA;AAEJ;AAAI;;EACE,kBAAA;AAGN;AADM;;;;;EAIE,+CAAA;EACA,iDAAA;AAIR;AAFQ;;;;;EACE,mBAAA;AAQV;AAJM;;EACE,+CAAA;EACA,4CAAA;AAOR;AALQ;;EACE,mBAAA;AAQV;AAJM;;EACE,kBAAA;EACA,kBAAA;AAOR;AALQ;;EACE,kBAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AAQV;AAJM;;EAGE,WAAA;EACA,gBAAA;EACA,iCAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AAKR;AAFM;;EACE,cAAA;AAKR;AAFM;;EACE,sBAAA;AAKR;AAFM;;EACE,WAAA;EACA,mBAAA;EACA,yBAAA;AAKR;AAFM;;EACE,gDAAA;AAKR;AAFM;;EACE,cAAA;AAKR;AAFM;;EACE,cAAA;AAKR;AAeM;;EACE,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iCAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAZR;AAkBI;;EACE,eAAA;EACA,mBAAA;AAfN;AAkBI;;EACE,eAAA;AAfN","sourcesContent":[".exam_test,\n.error_exam_block {\n  position: relative;\n\n  .question_block .question_Name {\n    position: relative;\n    padding-left: 30px;\n    font: 400 15px/25px \"Ubuntu\", sans-serif;\n\n    .question_No {\n      font: 600 16px/25px \"Ubuntu\", sans-serif;\n      position: absolute;\n      left: 0;\n      color: #00c596;\n    }\n  }\n\n  .question_options {\n    position: relative;\n\n    .single_card {\n      position: relative;\n\n      &:hover,\n      &:focus,\n      &:active,\n      &.active {\n        box-shadow: 0px 3px 20px hsla(0, 0%, 0%, 0.051);\n        border: 1px solid #00c5963d;\n\n        .option_name .option_No {\n          background: #c2f1e6;\n        }\n      }\n\n      &.incorrect {\n        box-shadow: 0px 3px 20px hsla(0, 0%, 0%, 0.051);\n        border: 1px solid hsla(14, 100%, 50%, 0.239);\n\n        .option_name .option_No {\n          background: #f1c2c2;\n        }\n      }\n\n      .option_name {\n        position: relative;\n        padding-left: 30px;\n\n        .option_No {\n          position: absolute;\n          left: 0;\n          width: 20px;\n          height: 20px;\n          line-height: 20px;\n          text-align: center;\n          border-radius: 4px;\n          color: #707070;\n          background: #eeeeee;\n        }\n      }\n\n      .custom-radio\n        .custom-control-input:checked\n        ~ .custom-control-label::after {\n        color: #fff;\n        content: \"\\f00c\";\n        font-family: \"Font Awesome 5 Pro\";\n        font-weight: 900;\n        background-image: none;\n        border-radius: 0.46rem;\n        text-align: center;\n        line-height: 16px;\n        font-size: 8px;\n      }\n\n      .custom-control-input:checked ~ .custom-control-label {\n        color: #00c596;\n      }\n\n      .custom-checkbox .custom-control-label::before {\n        border-radius: 0.45rem;\n      }\n\n      .custom-control-input:checked ~ .custom-control-label::before {\n        color: #fff;\n        background: #00c596;\n        border: 1px solid #00a881;\n      }\n\n      .custom-control-input:focus ~ .custom-control-label::before {\n        box-shadow: 0 0 0 0.2rem rgba(0, 168, 129, 0.25);\n      }\n\n      .correct {\n        color: #00c596;\n      }\n\n      .incorrect {\n        color: #ff0000;\n      }\n    }\n\n    .incorrect .custom-checkbox {\n      // .custom-control-label::before {\n      //     border-radius: 0.45rem;\n      // }\n\n      // .custom-control-label::after {\n      //     position: absolute;\n      //     top: 0.25rem;\n      //     left: -1.5rem;\n      //     display: block;\n      //     width: 1rem;\n      //     height: 1rem;\n      //     content: \"\";\n      //     background: no-repeat 50% / 50% 50%;\n      // }\n\n      .custom-control-input:checked ~ .custom-control-label::after {\n        color: #fff;\n        background: #ff0000;\n        border: 1px solid #f00101;\n        content: \"\\f00d\";\n        font-weight: 900;\n        font-family: \"Font Awesome 5 Pro\";\n        background-image: none;\n        border-radius: 0.46rem;\n        text-align: center;\n        line-height: 15px;\n        font-size: 10px;\n      }\n    }\n  }\n\n  .instruction {\n    button {\n      font-size: 13px;\n      border-radius: 25px;\n    }\n\n    .helpTags li i {\n      cursor: pointer;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
